import React from 'react'
import AnnounceExaminer from 'src/modules/AnnounceExaminer'

const AnnounceExaminerPage = () => {
  return <AnnounceExaminer />
}

export default AnnounceExaminerPage
